import { Component, OnInit } from '@angular/core';
import { MessagePayload, Messaging, NotificationPayload, onMessage } from '@angular/fire/messaging';
import { Router } from '@angular/router';
import { LeadService } from '@lfg-services/leads/lead.service';
import { Subscription } from 'rxjs';
import { User } from '@angular/fire/auth';
import { AuthenticationService } from '@lfg-services/authentication/authentication.service';
import { Provider } from '@lfg-interface/provider.interfaces';
import { environment } from 'src/environments/environment';
import { GlobalService } from '@lfg-services/global/global.service';
import { NotificationService } from '@lfg-services/notifications/notification.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  title = 'leads-finder-genie';
  AUTH_SUBSCRIPTION: Subscription = new Subscription();
  LOCATION_SUBSCRIPTION: Subscription = new Subscription();
  AUTH_STATUS!: User | null;
  PROVIDER_SUBSCRIPTION: Subscription = new Subscription();
  IS_TURN_ACTIVE: boolean | undefined = false;
  ENV_NAME: string = environment.name;
  DISPLAY_ENV_BAR: boolean = false;

  constructor(
              private messaging: Messaging,
              private router: Router,
              private leadsService: LeadService,
              private authService: AuthenticationService,
              private globalService: GlobalService,
              private notificationService: NotificationService
              ) {}

  ngOnInit(): void {
    this.getNotifications();
    this.getAuthStatus();
    this.setEnvBar();
  }

  setEnvBar(): void {
    this.DISPLAY_ENV_BAR = this.globalService.displayEnvironmentBar();
  }

  getAuthStatus(): void {
    this.AUTH_SUBSCRIPTION = this.authService.getAuthState().subscribe((response: User | null) => {
      this.AUTH_STATUS = response;
    });
  }

  getNotifications(): void {
    try {
      // Verificar capacidades de notificación
      const capabilities = this.notificationService.getNotificationCapabilities();
      // // // console.log('🔔 Capacidades de notificación:', capabilities);

      if (!capabilities.canUse) {
        // console.warn('⚠️ Notificaciones no disponibles:', capabilities.message);
        return;
      }

      onMessage(this.messaging, (message: MessagePayload) => {
        let chat_id: string = '';
        if (message.data !== null && message.data !== undefined) {
          chat_id = message.data['chat_id'];
        }
        this.createNewLocalNotification(message.notification, chat_id);
      });
    } catch (error) {
      // console.error('🔥 Error configurando notificaciones:', error);
      // No fallar la aplicación por problemas de notificaciones
    }
  }

  createNewLocalNotification(notification: NotificationPayload | undefined, chat_id: string | undefined): void {
    try {
      // Verificar si las notificaciones están soportadas
      if (!this.notificationService.canUseNotifications()) {
        // console.warn('⚠️ No se puede crear notificación local: API no soportada');
        // En iOS, mostrar alternativa (ej: toast, banner, etc.)
        this.showIOSAlternativeNotification(notification, chat_id);
        return;
      }

      // Crear notificación solo si está soportada
      if ('Notification' in window) {
        const LOCAL_NOTIFICATION: Notification = new Notification(`${notification?.title}`, {
          body: notification?.body,
          icon: notification?.icon || '/assets/icons/icon-192x192.png',
          tag: 'lfg-notification',
          requireInteraction: false
        });

        LOCAL_NOTIFICATION.onclick = () => {
          window.focus(); // Enfocar la ventana
          this.router.navigate(['/dashboard/chats'], {queryParams: {id: chat_id}});
          LOCAL_NOTIFICATION.close();
        };

        // Auto-cerrar después de 5 segundos
        setTimeout(() => {
          LOCAL_NOTIFICATION.close();
        }, 5000);
      }
    } catch (error) {
      // console.error('🔥 Error creando notificación local:', error);
      // Fallback para iOS u otros errores
      this.showIOSAlternativeNotification(notification, chat_id);
    }
  }

  private showIOSAlternativeNotification(notification: NotificationPayload | undefined, chat_id: string | undefined): void {
    // Alternativa para iOS: mostrar un banner temporal
    // // // console.log('📱 Mostrando notificación alternativa para iOS:', notification?.title);

    // Crear un banner visual temporal (ejemplo)
    const banner = document.createElement('div');
    banner.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #0d6efd;
      color: white;
      padding: 15px 20px;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.3);
      z-index: 10000;
      max-width: 300px;
      cursor: pointer;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      font-size: 14px;
      transition: all 0.3s ease;
    `;

    banner.innerHTML = `
      <div style="font-weight: bold; margin-bottom: 5px;">${notification?.title || 'Nueva notificación'}</div>
      <div style="opacity: 0.9;">${notification?.body || ''}</div>
    `;

    banner.onclick = () => {
      this.router.navigate(['/dashboard/chats'], {queryParams: {id: chat_id}});
      document.body.removeChild(banner);
    };

    document.body.appendChild(banner);

    // Auto-remover después de 5 segundos
    setTimeout(() => {
      if (document.body.contains(banner)) {
        banner.style.opacity = '0';
        setTimeout(() => {
          if (document.body.contains(banner)) {
            document.body.removeChild(banner);
          }
        }, 300);
      }
    }, 5000);
  }
}
